export const NO_DATA_PLACEHOLDER = '-';
